export const EVENTS = {
  FILE_REMOVED: "os_agents_file_removed",
  SEND_CLICKED: "os_agents_send_clicked",
  TOOL_SELECTED: "os_agents_tool_selected",
  MORE_TOOLS_TOGGLED: "os_agents_more_tools_toggled",
  OTHER_TOOL_SELECTED: "os_agents_other_tool_selected",
  PROMPT_ADD_CLICKED: "os_agents_prompt_add_clicked",
  PROMPT_EDIT_CLICKED: "os_agents_prompt_edit_clicked",
  PROMPT_DELETE_CLICKED: "os_agents_prompt_delete_clicked",
  PROMPT_SELECTED: "os_agents_prompt_selected",
  PROMPT_MODAL_CLOSED: "os_agents_prompt_modal_closed",
  PROMPT_SAVED: "os_agents_prompt_saved",
  MORE_PANEL_CLOSED: "os_agents_more_panel_closed",
  HISTORY_OPENED: "os_agents_history_opened",
  HISTORY_CLOSED: "os_agents_history_closed",
  EXIT_CLICKED: "os_agents_exit_clicked",
  SESSION_SELECTED: "os_agents_session_selected",
  SESSION_DELETED: "os_agents_session_deleted",
  CHAT_HISTORY_SELECTED: "os_agents_chat_history_selected",
  CHAT_HISTORY_DELETED: "os_agents_chat_history_deleted",
  MESSAGE_CARD_CLICKED: "os_agents_message_card_clicked",
  SUGGESTION_CLICKED: "os_agents_suggestion_clicked",
  THOUGHT_TIMER_TOGGLED: "os_agents_thought_timer_toggled",
  RECAP_CLOSED: "os_agents_recap_closed",
  EXECUTIVE_LINK_CLICKED: "os_agents_executive_link_clicked",
  PERSON_BRIEF_CLOSED: "os_agents_person_brief_closed",
  PERSON_BRIEF_TAB_CHANGED: "os_agents_person_brief_tab_changed",
  PERSON_BRIEF_SECTION_CLICKED: "os_agents_person_brief_section_clicked",
  ACCOUNT_PRIORITIES_CLOSED: "os_agents_account_priorities_closed",
  ACCOUNT_PRIORITY_SECTION_TOGGLED:
    "os_agents_account_priority_section_toggled",
  ACCOUNT_PRIORITY_RECOMMENDED_PEOPLE_CLICKED:
    "os_agents_account_priority_recommended_people_clicked",
  ACCOUNT_PRIORITY_BACK_CLICKED: "os_agents_account_priority_back_clicked",
  ORG_CHART_CLOSED: "os_agents_org_chart_closed",
  NEWS_CLOSED: "os_agents_news_closed",
  MESSAGE_TEMPLATE_CLOSED: "os_agents_message_template_closed",
  KEY_EXECUTIVES_CLOSED: "os_agents_key_executives_closed",
  JOBS_LIST_CLOSED: "os_agents_jobs_list_closed",
  JOBS_LIST_ITEM_CLICKED: "os_agents_jobs_list_item_clicked"
}

/**
 * Stable identity for a UI-component preview card within one assistant message.
 * Used to (a) switch/close the right-panel preview on card click (ENG-1905) and
 * (b) highlight the card that's currently open. MUST be computed identically
 * wherever a card is rendered (agent-id-messages-v2) and wherever a preview is
 * opened directly (agent-search-v2's streaming auto-open), so the open splitter
 * and the rendered card resolve to the same key. Prefers the plan step id
 * (unique per card); falls back to the card's index when there's no step id.
 */
export function getCardPreviewKey(
  messageId: string,
  card: { stepId?: string } | undefined,
  index: number
): string {
  return `${messageId}:${card?.stepId || index}`
}
